import React from "react";
import { ShowProps, Tab, TabbedShowLayout } from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import Logs from "./Logs";
import ShowWrapper from "../../components/ShowWrapper";

const ChangeRequestShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    { link: "/changeRequestForms", title: "Change Request Forms" },
    { link: `/changeRequestForms/${id}`, title: id },
  ];

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        isDefaultTitle
        isHaveSchoolFilter
        {...props}
      >
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              <Tab label="Logs">
                <Logs {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default ChangeRequestShow;
